import React from 'react';
import ChamberList from './Chamber';

const HospitalClinic = () => (
  <div className="hospital-clinic-container">
    {/* <h1>Hospitals & Clinics</h1> */}
    <ChamberList category="Clinic,hospital" />
  </div>
);

export default HospitalClinic;
